import { isEmpty, isNull } from "@utils/var.check";
export default {
  getGuidedSearchKeywordMap: function (searchText) {
    const anyWords = [];
    const exactWords = [];
    const includeWords = [];
    const excludeWords = [];

    const resultMap = {
      anyWords: anyWords,
      exactWords: exactWords,
      includeWords: includeWords,
      excludeWords: excludeWords,
      keywordIsEmpty: false,
      noPositiveWords: false,
    };

    function classifyText(word) {
      // for sign without word
      if (/^[+-]+$/.test(word)) {
        return;
      }

      // for word contain multiple sign in front, eg. ++---+word or -+--word
      const groupOfSign = /^[+-]+\s?/.exec(word);
      if (groupOfSign != null) {
        if (groupOfSign[0].match(/[-]*$/g)[0]) {
          // if last few sign is -, word will exclude
          excludeWords.push(truncateFrontSigns(word));
        } else {
          // else last few sign is +, word will include
          includeWords.push(truncateFrontSigns(word));
        }
        return;
      }

      // for word inside a double-quote, eg."student learning space"
      if (/^["](.+)["]$/g.test(word)) {
        exactWords.push(word);
        return;
      }

      anyWords.push(word);
    }

    function truncateFrontSigns(word) {
      // get word that ignore signs in front
      return /^[+-]+(.+)\s?/.exec(word)[1];
    }

    // split searchText by space, but ignore space in double-quote
    if (searchText === "" || isNull(searchText)) {
      resultMap.keywordIsEmpty = true;
    } else {
      const splitSearchText = searchText.match(/([^\w"*?\s]*"[^"]*"[^\w"*?\s]*|\S+)/g);
      splitSearchText.forEach(classifyText);

      resultMap.anyWords = anyWords;
      resultMap.exactWords = exactWords;
      resultMap.includeWords = includeWords;
      resultMap.excludeWords = excludeWords;

      if (anyWords.length === 0 && exactWords.length === 0 && includeWords.length === 0) {
        resultMap.noPositiveWords = true;
      }
    }
    return resultMap;
  },
  consolidateGuidedSearch(searchMap) {
    let consolidateSearch = "";
    const anyWordsGuidedSearch = searchMap.anyWords;
    const exactWordsGuidedSearch = searchMap.exactWords;
    const includeWordsGuidedSearch = searchMap.includeWords;
    const excludeWordsGuidedSearch = searchMap.excludeWords;

    if (anyWordsGuidedSearch.length !== 0) {
      const splitAnyWordsGuidedSearch = this.splitText(anyWordsGuidedSearch);
      const truncatedAnyWordsGuidedSearch = this.truncateWordsFrontSigns(splitAnyWordsGuidedSearch);
      if (truncatedAnyWordsGuidedSearch.length !== 0) {
        consolidateSearch += truncatedAnyWordsGuidedSearch.join(" ") + " ";
      }
    }

    // for multiple exact words from basic search with double quote and new exact words without double quote
    if (exactWordsGuidedSearch.length !== 0) {
      let doubleQuoteText = "";
      const consolidateExactWords = [];
      const splitWords = exactWordsGuidedSearch.split(" ");
      splitWords.forEach(function (text) {
        const groupOfSign = /^[+-]+\s?/.exec(text);
        if (
          (groupOfSign !== null && /^([+-]+["](.+))["]$/g.test(text)) ||
          (groupOfSign === null && /^["](.+)["]$/g.test(text))
        ) {
          // if text with both side double quote, eg. +-"text" or "text"
          if (doubleQuoteText.length !== 0) {
            consolidateExactWords.push(doubleQuoteText.trim());
            doubleQuoteText = "";
          }
          consolidateExactWords.push(removeDoubleQuote(text).trim());
        } else if (
          (groupOfSign != null && /^([+-]+(["](.+)))/g.test(text)) ||
          (groupOfSign === null && text.startsWith('"'))
        ) {
          // if text with front side double quote, eg. +-+"text or "text
          if (doubleQuoteText.length !== 0) {
            consolidateExactWords.push(doubleQuoteText.trim());
            doubleQuoteText = "";
          }
          doubleQuoteText += removeDoubleQuote(text) + " ";
        } else if (/(.+)["]$/g.test(text)) {
          // if text with back side double quote, eg. text"
          doubleQuoteText += removeDoubleQuote(text);
          consolidateExactWords.push(doubleQuoteText.trim());
          doubleQuoteText = "";
        } else {
          doubleQuoteText += removeDoubleQuote(text) + " ";
        }

        function removeDoubleQuote(word) {
          return word.replace(/["]+/g, "");
        }
      });
      if (doubleQuoteText.length !== 0) {
        consolidateExactWords.push(doubleQuoteText.trim());
      }

      const truncatedExactWordsGuidedSearch = this.truncateWordsFrontSigns(consolidateExactWords);
      if (truncatedExactWordsGuidedSearch.length !== 0) {
        consolidateSearch += '"' + truncatedExactWordsGuidedSearch.join('" "') + '"  ';
      }
    }

    if (includeWordsGuidedSearch.length !== 0) {
      const splitIncludeWordsGuidedSearch = this.splitText(includeWordsGuidedSearch);
      const truncatedIncludeWordsGuidedSearch = this.truncateWordsFrontSigns(
        splitIncludeWordsGuidedSearch,
      );
      if (truncatedIncludeWordsGuidedSearch.length !== 0) {
        consolidateSearch += "+" + truncatedIncludeWordsGuidedSearch.join(" +") + " ";
      }
    }

    if (excludeWordsGuidedSearch.length !== 0) {
      const splitExcludeWordsGuidedSearch = this.splitText(excludeWordsGuidedSearch);
      const truncatedExcludeWordsGuidedSearch = this.truncateWordsFrontSigns(
        splitExcludeWordsGuidedSearch,
      );
      if (truncatedExcludeWordsGuidedSearch.length !== 0) {
        consolidateSearch += "-" + truncatedExcludeWordsGuidedSearch.join(" -") + " ";
      }
    }
    return consolidateSearch;
  },
  truncateWordsFrontSigns(splitWords) {
    splitWords.forEach(function (text, index) {
      if (/^[+-]+$/.test(text)) {
        // for sign without word, remove from array
        splitWords.splice(index, 1);
      } else if (/^[+-]+(.+)\s?/.test(text)) {
        // for sign and word, truncate word front sign
        splitWords[index] = /^[+-]+(.+)\s?/.exec(text)[1];
      }
    });
    return splitWords;
  },
  splitText(searchText) {
    // split searchText by space, but ignore space in double-quote
    return searchText.match(/([^\w"*?\s]*"[^"]*"[^\w"*?\s]*|\S+)/g);
  },
  removeDoubleQuote(word) {
    return word.replace(/["]+/g, "");
  },
  hasSearchKeyword(keyword: string) {
    const keywordTrimmed = keyword?.trim();
    return !!(keywordTrimmed && !isEmpty(keywordTrimmed));
  },
};
